module.exports = __webpack_public_path__ + "static/blackcliff-longsword-cdd980161c86bdf06ff2b1f689a3ab39.png";